var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-spin',{attrs:{"spinning":!_vm.loading ? _vm.loadings : _vm.loading}},[_c('a-Config-provider',{attrs:{"locale":_vm.locale}},[_c('div',{attrs:{"id":"app"}},[_c('router-view')],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }